import EditMyProfile from 'components/RichProfile/EditMyProfile/EditMyProfile/EditMyProfile';

export default EditMyProfile;
